import React from "react";
import "./Services.css";
// import HearEmoji from "../../img/heartemoji.png";
// import Glasses from "../../img/glasses.png";
// import Humble from "../../img/humble.png";
// import Card_S from "../Card_S/Card_S";
// import Resume from "../../Component/Services/Resume.pdf";
// import { themeContext } from "../../Context";
// import { useContext } from "react";
// import { motion } from "framer-motion";
const Services = () => {
  // const transition = { duration: 2, type: "spring" };
  // const theme = useContext(themeContext);
  // const darkMode = theme.state.darkMode;
  return (
    <div className="Services" id="services">
      {/* LEFT SIDE */}
      
    </div>
  );
};

export default Services;
